import styled from "styled-components";

import { InlineButton as StyledInlineButton } from "components/atoms/Button";
import { colourScheme } from "utils/styling/colours";
import { Span, Text } from "utils/styling/typography.styled";

export const CommentContainer = styled.div`
    border-bottom: 1px solid ${colourScheme.white};
    padding: 0.5rem;
    background: none;
`;

export const CommentHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Username = styled(Span)`
    font-weight: bold;
    font-size: 1.25rem;
    color: ${colourScheme.secondary};
`;

export const CommentText = styled(Text)`
    font-size: 1rem;
    margin: 0.5rem 0;
    text-align: left;
`;

export const ActionButtons = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: flex-start;
`;

export const Icon = styled.div`
    display: inline-block;
    cursor: pointer;
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
`;

export const HeartCheckbox = styled.input.attrs({ type: "checkbox" })`
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
`;

export const IconWrapper = styled.div`
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;

    & img {
        width: 100%;
        height: 100%;
    }

    &:hover {
        transform: scale(1.1);
    }
`;

export const ReactContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const InlineButton = styled(StyledInlineButton)`
    opacity: 0.5;
    cursor: pointer;
`;

export const EditSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
`;

export const TextArea = styled.textarea`
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid ${colourScheme.grey};
    border-radius: 4px;
    resize: none;
`;

export const Timestamp = styled.span`
    font-size: 0.75rem;
    color: ${colourScheme.grey};
    margin-left: 0.5rem;
`;

export const EditedLabel = styled.span`
    font-size: 0.75rem;
    color: ${colourScheme.grey};
    margin-left: 0.5rem;
`;
